import _extends from "@babel/runtime/helpers/esm/extends";

var deserializeInitialState = function deserializeInitialState(viewModels, serializedInitialState) {
  var initialState = _extends({}, serializedInitialState, {
    viewModels: _extends({}, serializedInitialState.viewModels)
  });

  for (var viewModelIndex = 0; viewModelIndex < viewModels.length; viewModelIndex++) {
    var _viewModels$viewModel = viewModels[viewModelIndex],
        viewModelName = _viewModels$viewModel.name,
        deserializeState = _viewModels$viewModel.deserializeState;
    var viewModelInitialState = initialState.viewModels[viewModelName];

    for (var aggregateId in viewModelInitialState) {
      if (viewModelInitialState.hasOwnProperty(aggregateId)) {
        viewModelInitialState[aggregateId] = deserializeState(viewModelInitialState[aggregateId]);
      }
    }
  }

  return initialState;
};

export default deserializeInitialState;
//# sourceMappingURL=deserialize-initial-state.js.map